import { useEffect, useRef, useState } from 'react';
export function useRefState(initialState) {
    var _a = useState(initialState), state = _a[0], setState = _a[1];
    var ref = useRef(state);
    useEffect(function () {
        ref.current = state;
    }, [state]);
    return [state, setState, ref];
}
